// extracted by mini-css-extract-plugin
export default {"delete_icon":"CrawlLog_delete_icon__wpCNW","table_filter_head":"CrawlLog_table_filter_head__kAn7f","table_filter_delete_search":"CrawlLog_table_filter_delete_search__lDDmC"};